var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex items-center justify-center"},[_vm._v("List city relacted")])
}
var staticRenderFns = []

export { render, staticRenderFns }